<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full mb-4">
        <elsa-v-select
          :options="completeApartmentsTypes"
          label="name"
          v-model="generateApartmentsTypes"
          :reduce="item => item.id"
          :clearable="false"
          @input="generateApartmentsTypesError=false"
          :danger="generateApartmentsTypesError"
          danger-text="Выберите тип помещения"
          htmlLabel="Тип помещений"
          style-type="largeLabel"
        />
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full mb-4">
        <label>До какого числа необходимо оплатить</label>
        <elsa-v-datepicker
          v-model="generatePaymentMonth"
          :danger.sync="generatePaymentMonthError"
          danger-text="Выберите дату"
          :disabled="!generatePaymentMonth"
          :clearable="false"
        />
      </div>
    </div>

    <div class="vx-row mt-8 mb-4">

      <div class="vx-col w-full flex items-center justify-between">
        <h5>Индивидуальные тексты</h5>
        <div
          class=""
          @click.stop="invoicesText.push(Object.assign({}, invoicesTextObject, {limit_date: generatePaymentMonth}))"
        >
          <app-icon name="PlusIcon" size="12px" class="link-icon" />
        </div>
      </div>
      <vs-divider />


      <div
        class="vx-col w-full mb-4 relative" stlye="padding-top: 5px"
        v-for="(invoiceText, invoiceTextIndex) in invoicesText" :key="invoiceTextIndex"
      >
        <div
          @click.stop="invoicesText.splice(invoiceTextIndex, 1)"
          style="position: absolute; right: 15px; top: 0; color: rgba(var(--app-danger));"
        >
          <app-icon name="TrashIcon" size="18px" />
        </div>


        <div class="vx-col w-full mb-4">
          <label>До какого числа необходимо оплатить</label>
          <app-datepicker v-model="invoiceText.limit_date" />
        </div>

        <div class="vx-col w-full mb-4">
          <label>Список счетов</label>
          <v-select
            :options="apartments"
            :selectable="isAccountSelectable"
            label="account_number"
            v-model="invoiceText.account_numbers"
            class="app-v-select app-v-select_multiple invoice-generate-text-select"
            :reduce="option => option.account_number"
            :key="`select`"
            :multiple="true"
            maxHeight="200px"
          >
            <template slot="selected-option" slot-scope="option">
              <div style="display: flex; align-items: center;">
                {{ option.account_number }}

              </div>
            </template>
            <template slot="option" slot-scope="option">
              <div :class="$style.option">
                {{ option.account_number }}
                <span :class="$style.accountLabel">
                  <span v-if="!option.pass_date">Нет акта ПП</span>
                  <span v-if="selectedAccounts[option.account_number]"> Уже выбран</span>
                </span>
              </div>
            </template>
            <template slot="no-options">
              Лицевые счета не найдены
            </template>
          </v-select>
          <!--            <app-input v-model="" :danger.sync="invoiceText.accError"-->
          <!--                       danger-text="Введите список счетов"/>-->
        </div>

        <div class="vx-col w-full mb-4">
          <label>Текст</label>
          <elsa-v-select
            :options="templates"
            label="template_text"
            v-model="invoiceText.textTemplate"
            @input="invoiceText.textTemplateError = false"
          />
          <div v-if="invoiceText.textTemplateError" :class="$style.errorText">
            Обязательное поле
          </div>
          <div v-if="invoiceText.textTemplate && invoiceText.textTemplate.id === -1" class="mt-2">
            <elsa-quill-editor
              v-model="invoiceText.text"
              :options="extraTextEditorConfig"

            />
          </div>
        </div>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full flex justify-center">
        <vs-button
          id="generate-button"
          type="border"
          class="vs-con-loading__container"
          :disabled="loading"
          @click="onSubmit"
        >
          Начать генерацию
        </vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import notifyHttpError      from "@/mixins/notifyHttpError";
import quarterDisabledDates from "@/mixins/quarterDisabledDates";
import _pick                from "lodash/pick";
import ElsaQuillEditor      from "@/components/ElsaQuillEditor";
import modalContext         from "@/mixins/modalContext";

export default {
  name:       "InvoicesGeneratePopup",
  mixins:     [quarterDisabledDates, notifyHttpError, modalContext],
  components: {
    ElsaQuillEditor,
  },
  data() {
    return {
      loading: false,

      generateApartmentsTypes:      -1,
      generateApartmentsTypesError: false,
      generatePaymentMonth:         null,
      generatePaymentMonthError:    false,

      allApartments: [],
      templates:     [],

      invoicesText:       [],
      invoicesTextObject: {
        account_numbers:   [],
        limit_date:        null,
        text:              null,
        textTemplate:      null,
        accError:          false,
        textTemplateError: false,
      },

      extraTextEditorConfig: {
        modules: {
          toolbar:   ['bold', 'italic', 'underline'],
          clipboard: {
            matchers: [
              [Node.ELEMENT_NODE, ( node, delta ) => {
                delta.ops = delta.ops.map(op => ({
                  ...op,
                  attributes: _pick(op.attributes, ["bold", "italic", "underline"]),
                }));
                return delta;
              }],
            ],
          },
        },
      },
    };
  },
  computed: {
    userId() {
      return this.$store.getters['appUser/id'];
    },

    apartmentsTypes() {
      return this.$store.getters['appUser/availableApartmentsTypes'];
    },

    completeApartmentsTypes() {
      return [{ id: -1, name: 'Все' }].concat(this.apartmentsTypes);
    },

    selectedDate() {
      return new Date(this.$store.getters['appUser/selectedDate']) || null;
    },

    selectedHouseId() {
      return this.$store.getters['appUser/selectedHouse'].id;
    },

    selectedAccounts() {
      return this.invoicesText.reduce(( takenDict, invoiceText ) => {
        invoiceText.account_numbers.forEach(number => takenDict[number] = true);
        return takenDict;
      }, {});
    },

    apartments() {
      if (this.generateApartmentsTypes === -1) return this.allApartments;
      return this.allApartments.filter(apartment => apartment.type_apart === this.generateApartmentsTypes);
    },
  },
  methods:  {
    loadBeforeDay() {
      this.$http.get(`/house/${this.selectedHouseId}/pay/before/day`, { params: { buildings_id: this.selectedHouseId } }).then(( { data } ) => {
        this.updatePaymentMonth(+data.parameters);
      }, () => {
        this.updatePaymentMonth(10);
      });
    },

    saveBeforeDay( day ) {
      this.$http.post(`/house/${this.selectedHouseId}/pay/before/day`, {
        buildings_id: this.selectedHouseId,
        day,
      }).then(( { data } ) => {
        console.log(data);
      });
    },

    loadTemplates() {
      this.$http.get(`kv_templates_texts`, { buildings_id: this.selectedHouseId }).then(( { data } ) => {
        this.templates = [...data, { id: -1, template_text: 'Свой текст...' }];
      });
    },

    loadApartments() {
      this.$http.get('all_aparts', { params: { buildings_id: this.selectedHouseId } }).then(( { data } ) => {
        this.allApartments = data.filter(apartment => apartment.account_number);
      });
    },

    updatePaymentMonth( day ) {
      const month = new Date(this.selectedDate);
      month.setDate(day);
      month.setMonth(month.getMonth() + 1);
      this.generatePaymentMonth = month;
    },

    updateLoading() {
      if (this.loading) {
        this.$vs.loading({
          container: '#generate-button',
          scale:     .5,
        });

      } else {
        this.$vs.loading.close('#generate-button > .con-vs-loading');
      }
    },

    async onSubmit() {
      if (this.generateApartmentsTypes === null) {
        this.generateApartmentsTypesError = true;
        return false;
      }

      if (this.generatePaymentMonth === null) {
        this.generatePaymentMonthError = true;
        return false;
      }

      let hasError = false;

      const invoicesText = this.invoicesText.map(invoiceText => {
        let html = '';
        if (!invoiceText.textTemplate) {
          invoiceText.textTemplateError = true;
          hasError = true;
        } else {
          html = invoiceText.textTemplate.id === -1
            ? invoiceText.text.trim()
            : invoiceText.textTemplate.template_text;
        }
        return {
          account_numbers: invoiceText.account_numbers.join(','),
          limit_date:      this.$options.filters.moment(invoiceText.limit_date, 'DD.MM.YYYY'),
          text:            html,
        };
      });

      if (hasError) {
        return false;
      }

      let params = {
        buildings_id: this.selectedHouseId,
        month:        this.$options.filters.formatDate(this.selectedDate),
        who:          this.userId,
        limit_date:   this.$options.filters.moment(this.generatePaymentMonth, 'DD.MM.YYYY'),
        custom_texts: JSON.stringify(invoicesText),
      };

      if (this.generateApartmentsTypes !== -1) {
        params.apartments_type = this.generateApartmentsTypes;
      }

      this.loading = true;

      this.saveBeforeDay(this.generatePaymentMonth.getDate());

      this.$http.post('pdf', params).then(
        () => {
          this.$vs.notify({ color: 'success', title: 'Ожидайте', text: 'Генерация началась' });
          this.modalResolve();
        },
        ( e ) => {
          this.loading = false;
          this.notifyHttpError(e);
        },
      );
    },

    isAccountSelectable( account ) {
      return !this.selectedAccounts[account] && account.pass_date;
    },
  },
  mounted() {
    this.loadApartments();
    this.updateLoading();
    this.loadTemplates();
    this.loadBeforeDay();
  },
  beforeDestroy() {
  },
  watch: {
    loading() {
      this.updateLoading();
    },
    apartments( apartments ) {
      const apartmentsDict = apartments.reduce(( dict, apartment ) => {
        dict[apartment.account_number] = true;
        return dict;
      }, {});
      this.invoicesText.forEach(invoiceText => {
        invoiceText.account_numbers = invoiceText.account_numbers.filter(number => apartmentsDict[number]);
      });
    },
  },
};
</script>

<style lang="scss" module>
.errorText {
  position: relative;
  font-size: .65rem;
  overflow: hidden;
  transition: all .25s ease;
  color: rgba(var(--vs-danger), 1);
  padding: 2px 4px 4px;
}

.option {
  display: flex;
  align-items: center;
}

.accountLabel {
  margin-left: auto;
  color: color(danger);
  opacity: .5;
  font-size: .8em;
}
</style>
